import { PUBLIC_DOC_PATH, publicDocResponseSchema } from '@/contract';
import { richDocFrom } from '@/mock';
import type { EpochMs, PublicDocBackend } from '@/mock';

export function createPublicDocBackend(): PublicDocBackend {
  return {
    async fetchByToken(token) {
      const response = await fetch(`${PUBLIC_DOC_PATH}?token=${encodeURIComponent(token)}`);
      if (response.status === 404) return null;
      if (!response.ok) throw new Error(`Публичный документ не получен: ${response.status}`);
      const body = publicDocResponseSchema.parse(await response.json());
      return { ...body, bodyJson: richDocFrom(body.bodyJson), updatedAt: body.updatedAt as EpochMs };
    },
  };
}
